export class CustomParamsBillingInvoiceModel {
  InvoiceHistoryID: number;
  InvoiceDate: string;
  InvoiceDateNumber: number;
}
